import React from "react";
const OneToOneChat = ()=>{
    return (<>
        One to one chat
    </>)
}
export default OneToOneChat;